module.exports = __webpack_public_path__ + "assets/logo-white.42bfed38.png";